
import Vue from "vue";
import { CompanyService } from "@/services/company-service";
import { copyToClipboard } from "@/utils/clipboard";
import AppErrorMessage from "@/components/common/ErrorMessageBox.vue";
import { HttpError } from "@/utils/services/http-error";

export default Vue.extend({
	data(){
		return {
			referralLink: "",
			referralCode: "",
			inviteEmail: "",
			inviteError: "",
			sending: false,
			referrals: [] as any[],
			invites: [] as any[]
		};
	},
	computed: {
		canInvite():boolean{
			return this.inviteEmail.includes("@") && !this.sending;
		},
		pendingInvites():any[]{
			return this.invites.filter(i => i.status != "registered");
		},
		totalYearlyReward():number{
			return this.referrals.reduce((sum, r) => sum + (r.yearlyReward || 0), 0);
		}
	},
	methods: {
		selectAll(event:FocusEvent){
			let target = event.target as HTMLInputElement;
			if (target && target.select){
				target.select();
			}
		},
		copyLink(){
			copyToClipboard(this.referralLink);
			this.$wf.notify(this.$ct("link-copied").toString(), "success", 3000, "check");
		},
		share(type:string){
			let link = this.referralLink;
			let text = this.$ct("share-message").toString() + " " + link;
			let url = "";
			console.log(encodeURIComponent(text));
			if (type == "whatsapp"){
				url = "https://wa.me/?text=" + encodeURIComponent(text);
			}else if (type == "linkedin"){
				url = "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(link);
			}else if (type == "email"){
				url = "mailto:?subject=" + encodeURIComponent(this.$ct("share-email-subject").toString())
					+ "&body=" + encodeURIComponent(text);
			}
			window.open(url, "_blank", "noopener");
		},
		formatDate(date:string):string{
			if (!date) return "";
			return new Date(date).toLocaleDateString();
		},
		formatReward(value:number):string{
			return "€ " + value.toLocaleString("nl-BE");
		},
		async sendInvite(){
			if (!this.canInvite) return;
			this.inviteError = "";
			this.sending = true;
			try{
				await CompanyService.sendReferralInvite(this.inviteEmail.trim());
				this.inviteEmail = "";
				this.$wf.notify(this.$ct("invite-sent").toString(), "success", 3000, "check");
				await this.loadReferrals();
			}catch(err){
				let error = err as HttpError;
				error.dontShow = true;
				this.inviteError = error.getText();
			}finally{
				this.sending = false;
			}
		},
		async loadInfo(){
			let info = await CompanyService.getReferralInfo();
			this.referralCode = info.code;
			this.referralLink = info.link;
		},
		async loadReferrals(){
			let data = await CompanyService.getReferrals();
			this.referrals = data.referrals;
			this.invites = data.invites;
		}
	},
	async created(){
		await Promise.all([this.loadInfo(), this.loadReferrals()]);
	},
	components: {
		AppErrorMessage
	},
	i18nEx: {
		componentPrefix: "views.account.referrals"
	}
});
